import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "share1",
  "use": "share1-usage",
  "viewBox": "0 0 23.955 19.746",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 23.955 19.746\" id=\"share1\"><defs><style>#share1 .a{fill:none;stroke:#342f41;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}</style></defs><path class=\"a\" d=\"M23.186,8.2,12.84.75V4.07C-.209,4.174.767,19,.767,19s-.011-7.27,12.073-7.325v3.973Z\" transform=\"translate(0.02)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol